import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
};

export async function getInventory(params = {}, token) {
  const res = await axios.get(`${API}/inventory`, {
    params,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function createInventoryItem(payload, token) {
  const res = await axios.post(`${API}/inventory`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function seedStarterInventory(token) {
  const res = await axios.post(`${API}/inventory/starter`, {}, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateInventoryItem(itemId, payload, token) {
  const res = await axios.put(`${API}/inventory/${itemId}`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateInventoryQuantity(itemId, payload, token) {
  const res = await axios.post(`${API}/inventory/${itemId}/quantity`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function deleteInventoryItem(itemId, token) {
  const res = await axios.delete(`${API}/inventory/${itemId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}
